import {ActionTree} from "vuex";
import {DataProfileState, DataProfile} from "./model";
import {RootStateType} from "@/store";
import {AxiosResponse} from "axios";

const actions: ActionTree<DataProfileState, RootStateType> = {
  findList({rootGetters, commit}, params) {
    return rootGetters['hcs/client'].get('/data_profiles', {params: params})
        .then((response: AxiosResponse) => {
          const dataProfiles: DataProfile[] = response.data;
          commit('setDataProfiles', dataProfiles);
          return dataProfiles;
        });
  },
  get({ rootGetters, commit }, params) {
    const id = params.id;
    delete params.id;
    return rootGetters['hcs/client'].get(`/data_profiles/${id}`, { params: params })
        .then((response: AxiosResponse) => {
          return response.data as DataProfile
        })
  },
  create({rootGetters, commit}, params) {
    return rootGetters['hcs/client'].post('/data_profiles', params)
        .then((response: AxiosResponse) => {
          const dataProfile: DataProfile = response.data;
          commit('addDataProfile', dataProfile);
          return dataProfile;
        });
  },
  update({rootGetters, commit}, params) {
    return rootGetters['hcs/client'].patch(`/data_profiles/${params.id}`, params)
        .then((response: AxiosResponse) => {
          const dataProfile: DataProfile = response.data;
          commit('updateDataProfile', dataProfile);
          return dataProfile;
        });
  },
  delete({rootGetters, commit}, id) {
    return rootGetters['hcs/client'].delete(`/data_profiles/${id}`)
        .then((response: AxiosResponse) => {
          commit('deleteDataProfile', id);
        });
  }
}

export default actions;
